export const SLOW_REQUEST_TIME = 1000

export const EVENTS = {
  tab: 'Tab Selection',
  filters: 'Filters Change',
  orderBy: 'Order By Change',
  tableChart: 'Table/Chart Selection',
  // Notes right-column (rail redesign) — usage instrumentation. Fullscreen is
  // tracked specifically to decide whether it earns its toolbar slot.
  notesOpen: 'Notes Panel Open',
  notesCollapse: 'Notes Panel Collapse',
  notesTab: 'Notes Tab Selection',
  notesFullscreen: 'Notes Fullscreen',
  notesQuickAdd: 'Notes Quick Add',
  notesResize: 'Notes Panel Resize',
  // Which home-dashboard widgets people actually click. Phase 2 of the Atlas
  // User Dashboard prioritizes role widgets off this, so it needs to be
  // collected from the moment phase 1 ships.
  dashboardWidget: 'Dashboard Widget Click',
}

export const CATEGORIES = {
  clientPage: 'Client Page Visualizations',
  clientAccountActivity: 'Account activity table',
  clientLoanLedger: 'Loan ledger table',
  clientAmendments: 'Client amendments table',
  capTableTable: 'Cap table table',
  dilutionSummary: 'Dilution summary table',
  dilutionOverTimeTable: 'Dilution over time table',
  dilutionOverTimeChart: 'Dilution over time chart',
  arRollforwardTable: 'AR rollforward table',
  arRollforwardChart: 'AR rollforward chart',
  apRollforwardTable: 'AP rollforward table',
  bankTransactionsTable: 'Bank transactions table',
  bankTransactionsChart: 'Bank transactions chart',
  ineligibleARTable: 'Ineligible AR table',
  ineligibleInventoryTable: 'Ineligible inventory table',
  inventoryDistributionTable: 'Inventory distribution table',
  inventoryDistributionChart: 'Inventory distribution chart',
  arSummary: 'Receivables summary table',
  arSummaryChart: 'Receivables summary chart',
  apSummary: 'Payables summary table',
  apSummaryChart: 'Payables summary chart',
  salesBySKUVisualizationTable: 'Performance by SKU table',
  salesBySKUVisualizationChart: 'Performance by SKU chart',
  financialsISTable: 'Financials Income Statement table',
  financialsISChart: 'Financials Income Statement chart',
  financialsBSTable: 'Financials Balance sheet table',
  financialsBSChart: 'Financials Balance sheet chart',
  cashFlowTable: 'Cash Flow table',
  cashFlowChart: 'Cash Flow chart',
  riskRatingVisualization: 'Risk rating chart',
  inventoryHealthVisualization: 'Inventory health chart',
  collectionsReconciliation: 'Collections & Dilution Reconciliation',
  salesChannelDistribution: 'Sales Channel Distribution',
  pendingCashDominion: 'Pending Cash Dominion',
  notesSidebar: 'Notes Sidebar',
  dashboardMyWork: 'Dashboard My Work widget',
  dashboardCalendar: 'Dashboard Today widget',
  dashboardMyClients: 'Dashboard My Clients widget',
  dashboardDiligence: 'Dashboard Diligence Pipeline widget',
  dashboardProspects: 'Dashboard Prospect Pipeline widget',
  dashboardDealCleanup: 'Dashboard Deal Cleanup widget',
}
